/**
 * Attribute-master API service.
 *
 * Endpoint:
 *   GET /api/attribute?category=<category>
 *
 * Returns the list of attribute definitions for the given category (e.g.
 * TRUCK_BODY_AMBULANCE). These definitions are used to dynamically generate
 * form fields in the Body Information section.
 */

import apiClient from './apiClient'
import { ATTRIBUTE } from './apiEndpoints'

export interface AttributeDefinition {
  id: number
  category: string
  /** Maps to the form field id */
  attribute_name: string
  /** Display label for the field */
  label: string
  /** 'string' | 'number' | 'boolean' */
  data_type: string
  /** 'text' | 'select' | 'toggle' | 'checkbox' | 'number' | 'textarea' */
  control_type: string
  /** Used to sort fields in the rendered form */
  display_order: number
  is_required: boolean
  /** Shared ref_master category key. When set, overrides the vehicle-specific derived key. */
  ref_category?: string | null
}

interface AttributeResponse {
  success: boolean
  data: {
    category: string
    attributes: AttributeDefinition[]
  }
}

/**
 * Fetch attribute definitions for a given category from the attribute_master table.
 * Returns an empty array on failure or when the response contains no attributes.
 */
export async function fetchAttributeDefinitions(
  category: string
): Promise<AttributeDefinition[]> {
  const response = await apiClient.get<AttributeResponse>(ATTRIBUTE, {
    params: { category },
  })
  return response.data?.data?.attributes ?? []
}
